export enum enteteTableauListeComptesTauxRecuperabiliteSouspostesEnum {
	compte = 'Compte',
	tauxRecupResidentiel = 'Taux récup. résidentiel',
	tauxRecupBureau = 'Taux récup. bureau',
	codeSousPoste = 'Code sous-poste',
}